import i18n from "i18next";
import LocalStorageBackend from "i18next-localstorage-backend";
import HttpBackend from "i18next-http-backend";
import ChainedBackend from "i18next-chained-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { registryRequest } from "./registry-request";
import { registryParse } from "./registry-parse";

export const onInitService = ({ getConfig, getContext, createExtension }) => {
  const defaultConfig = {
    backend: {
      backends: [LocalStorageBackend, HttpBackend],
      backendOptions: [
        // LocalStorageBackend
        // - manage TTL
        {
          expirationTime: getConfig("one.i18n.options.expirationTime", 3600000)
        },
        // HttpBackend
        // - url to the registry service
        // - handle versioned namespaces requests
        // - parse registry service response format
        {
          loadPath: [
            getContext("one.axios.proxy.baseUrl"),
            getContext("one.axios.proxy.registry.key"),
            getConfig("one.i18n.registry.bucket.name", "i18n"),
            getConfig("one.i18n.registry.key.template", "{{ns}}--{{lng}}")
          ].join("/"),
          // Interoperate with the Registry Service format
          request: registryRequest,
          parse: registryParse
        }
      ]
    },
    // Generic options
    load: getConfig("one.i18n.options.load", "languageOnly"),
    ns: getConfig("one.i18n.options.ns", ["react-sdk"]),
    defaultNS: getConfig("one.i18n.options.defaultNS", "app"),
    fallbackLng: getConfig("one.i18n.options.fallbackLng", "en"),
    // TODO: should we make this compatible with suspence so that the first load
    //       won't show the default translations?
    //       Is there a way to preload translations from HTML?
    //       Partial server-side rendering?
    react: {
      useSuspense: getConfig("one.i18n.options.react.useSuspense", false)
    }
  };

  const defaultMiddlewares = [
    ChainedBackend,
    LanguageDetector,
    initReactI18next
  ];

  // Override i18n configuration
  const { value: config } = createExtension.waterfall(
    "$ONE_I18N_OVERRIDE_CONFIG",
    defaultConfig
  );

  // Override i18n middlewares
  const { value: middlewares } = createExtension.waterfall(
    "$ONE_I18N_OVERRIDE_MIDDLEWARES",
    defaultMiddlewares
  );

  for (const middleware of middlewares) {
    i18n.use(middleware);
  }

  i18n.init(config);
};
